import { Outlet } from "react-router";

import { Typography } from "@mui/material";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { PageContainer } from "@toolpad/core/PageContainer";

import { useStore } from "../zustand-store";

const UserNav = () => {
  const user = useStore((s) => s.user);
  return (
    <Typography component="div" fontWeight="fontWeightBold">
      {user?.username || "Unknown User"}
      <br />
      {user?.customerId || "Missing Customer ID"}
    </Typography>
  );
};

export default function Layout() {
  return (
    <>
      <DashboardLayout
        defaultSidebarCollapsed={true}
        slots={{
          toolbarActions: UserNav,
        }}
      >
        <PageContainer maxWidth={false} breadcrumbs={[]}>
          {/* Renders route children */}
          <Outlet />
        </PageContainer>

        {/* Global Modals Here */}
        <></>
      </DashboardLayout>
    </>
  );
}
